<template>
  <vh-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    width="850px"
    modal
    custom-class="VmpAIChatDialog"
    append-to-body
  >
    <template v-if="activeView == 'list'">
      <template slot="title">
        <span class="pageTitle">{{ $t('host.k_630001') }}</span>
        <vh-tooltip placement="bottom-start">
          <div slot="content">
            {{ $t('host.k_630002') }}
            <br />
            {{ $t('host.k_630003') }}
            <br />
            {{ $t('host.k_630004') }}
            <br />
            {{ $t('host.k_630005') }}
            <br />
            {{ $t('host.k_630006') }}
            <br />
            {{ $t('host.k_630007') }}
            <br />
            {{ $t('host.k_630008') }}
          </div>
          <i class="iconfont-v3 saasicon_help_m"></i>
        </vh-tooltip>
      </template>
      <div class="mainContent" v-loading="loading">
        <vh-tabs
          v-show="!noData && !loading"
          v-model="activeName"
          @tab-click="handleClick"
          v-if="dialogVisible"
        >
          <vh-tab-pane :label="$t('host.k_630009')" name="topic">
            <TopicTb
              ref="topic"
              @upTotal="upTotal"
              @returnStep="returnStep"
              @editTopic="editTopic"
            ></TopicTb>
          </vh-tab-pane>
          <vh-tab-pane :label="$t('host.k_630010')" name="bot">
            <BotTb ref="bot" @returnStep="returnStep"></BotTb>
          </vh-tab-pane>
        </vh-tabs>
        <div class="no-data" v-show="noData && !loading">
          <img src="./img/no-file.png" alt="" />
          <p>{{ $t('host.k_630011') }}</p>
          <vh-button round type="primary" size="medium" @click="editTopic">
            {{ $t('host.k_630012') }}
          </vh-button>
        </div>
      </div>
    </template>
    <template v-else>
      <template slot="title">
        <span class="title-back" @click="activeView = 'list'">
          <i class="vh-iconfont vh-line-arrow-left"></i>
          {{ curEditTopic ? $t('host.k_630013') : $t('host.k_630012') }}
        </span>
      </template>
      <EditTopic
        :topicId="curEditTopic?.id"
        v-if="activeView == 'edit'"
        @saveSuccess="activeView = 'list'"
      ></EditTopic>
    </template>
  </vh-dialog>
</template>
<script>
  import { useMsgServer, useRoomBaseServer } from 'middle-domain';
  import TopicTb from './topicTb';
  import BotTb from './botTb';

  export default {
    name: 'VmpAIChat', // 发起端AI聊天列表弹窗
    components: {
      TopicTb,
      BotTb,
      EditTopic: () => import('./edit.vue')
    },
    data() {
      const { watchInitData = {} } = this.roomBaseServer.state;
      const { webinar = {} } = watchInitData;
      return {
        dialogVisible: false,
        env: process.env.VUE_APP_ENV,
        webinarId: webinar.id,
        noData: true,
        activeName: 'topic',
        loading: true,
        activeView: 'list',
        curEditTopic: null
      };
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
      this.msgServer = useMsgServer();
    },
    async created() {
      this.initEvents();
    },
    methods: {
      /**
       * 对话框打开事事件
       */
      openDialog() {
        this.loading = true;
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
        this.showCreate = false;
        this.CardClick = false;
        this.activeView = 'list';
      },
      initEvents() {
        this.$emitter.on(this.$EMIT_DEFINE.ai_chat_open, res => {
          this.openDialog();
        });
      },
      handleClick(tab) {
        let name = tab.name;
        this.$refs[name].initComponent();
      },
      returnStep(name) {
        this.activeName = name;
      },
      upTotal(count) {
        this.noData = !count;
        this.loading = false;
      },
      editTopic(topicData) {
        this.curEditTopic = topicData;
        this.activeView = 'edit';
      }
    }
  };
</script>
<style lang="less">
  .VmpAIChatDialog {
    .vh-dialog__body,
    .mainContent {
      min-height: 300px;
    }
    .no-data {
      text-align: center;
      margin-top: 70px;
      p {
        margin: 12px auto;
      }
    }
    .title-back {
      cursor: pointer;
    }
  }
</style>
